import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Bitcoin, Menu, X } from 'lucide-react';
export function Header() {
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const navItems = [{
    path: '/',
    label: 'Home'
  }, {
    path: '/top100',
    label: 'Top 100'
  }, {
    path: '/methodology',
    label: 'Methodology'
  }];
  const isActive = (path: string) => location.pathname === path;
  return <header className="sticky top-0 z-50 bg-gray-900/95 backdrop-blur-sm border-b border-gray-800" data-id="element-52">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-53">
        <div className="flex items-center justify-between h-16" data-id="element-54">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2 group" data-id="element-55">
            <div className="w-10 h-10 bg-gradient-to-br from-orange-500 to-orange-600 rounded-lg flex items-center justify-center group-hover:scale-105 transition-transform" data-id="element-56">
              <Bitcoin className="w-6 h-6 text-white" data-id="element-57" />
            </div>
            <div className="flex flex-col" data-id="element-58">
              <span className="text-xl font-bold text-white font-mono" data-id="element-59">
                TOP100
              </span>
              <span className="text-xs text-orange-500 font-mono -mt-1" data-id="element-60">
                BITCOIN
              </span>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-1" data-id="element-61">
            {navItems.map(item => <Link key={item.path} to={item.path} className={`px-4 py-2 rounded-lg font-medium transition-colors ${isActive(item.path) ? 'bg-orange-500/10 text-orange-500' : 'text-gray-300 hover:text-white hover:bg-gray-800'}`} data-id="element-62">
                {item.label}
              </Link>)}
          </nav>

          {/* Mobile Menu Button */}
          <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="md:hidden p-2 text-gray-300 hover:text-white hover:bg-gray-800 rounded-lg transition-colors" data-id="element-63">
            {mobileMenuOpen ? <X className="w-6 h-6" data-id="element-64" /> : <Menu className="w-6 h-6" data-id="element-65" />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {mobileMenuOpen && <nav className="md:hidden py-4 border-t border-gray-800" data-id="element-66">
            {navItems.map(item => <Link key={item.path} to={item.path} onClick={() => setMobileMenuOpen(false)} className={`block px-4 py-3 rounded-lg font-medium transition-colors ${isActive(item.path) ? 'bg-orange-500/10 text-orange-500' : 'text-gray-300 hover:text-white hover:bg-gray-800'}`} data-id="element-67">
                {item.label}
              </Link>)}
          </nav>}
      </div>
    </header>;
}